module.exports = __webpack_public_path__ + "img/slide-about-1.db46f66b.png";